// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"70":"00076055","160":"b986aacf","906":"962c310a"}[chunkId] + ".js";
};